import { render, staticRenderFns } from "./PowerTime.vue?vue&type=template&id=140dfb97&scoped=true&"
import script from "./PowerTime.vue?vue&type=script&lang=js&"
export * from "./PowerTime.vue?vue&type=script&lang=js&"
import style0 from "./PowerTime.vue?vue&type=style&index=0&id=140dfb97&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140dfb97",
  null
  
)

export default component.exports